const DISLIKED_JOBS_KEY = "dislikedJobs";
const DISLIKE_THRESHOLD_DAYS = 30;
const MAX_DISLIKED_JOBS = 1000;

function getDislikedJobMap(): Record<string, number> | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const rawDislikedJobs = window.localStorage.getItem(DISLIKED_JOBS_KEY);
    if (!rawDislikedJobs) {
      return {};
    }

    const parsed: unknown = JSON.parse(rawDislikedJobs);
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      return {};
    }

    const removalTimestamp = Date.now() - DISLIKE_THRESHOLD_DAYS * 24 * 60 * 60 * 1000;
    const dislikedJobs = Object.entries(parsed).reduce<Record<string, number>>(
      (result, [jobKey, timestamp]) => {
        if (typeof timestamp === "number" && timestamp > removalTimestamp) {
          result[jobKey] = timestamp;
        }
        return result;
      },
      {},
    );

    return dislikedJobs;
  } catch {
    return null;
  }
}

export function getStoredViewJobDislikeState(jobKey: string): Promise<boolean | null> {
  const dislikedJobs = getDislikedJobMap();
  return Promise.resolve(dislikedJobs === null ? null : jobKey in dislikedJobs);
}

export function setStoredViewJobDislikeState(jobKey: string, isDisliked: boolean): Promise<void> {
  const dislikedJobs = getDislikedJobMap();
  if (dislikedJobs === null) {
    return Promise.resolve();
  }

  if (isDisliked) {
    dislikedJobs[jobKey] = Date.now();

    const keys = Object.keys(dislikedJobs);
    if (keys.length > MAX_DISLIKED_JOBS) {
      const oldestJobKey = keys.reduce((oldest, current) =>
        dislikedJobs[current] < dislikedJobs[oldest] ? current : oldest,
      );
      delete dislikedJobs[oldestJobKey];
    }
  } else {
    delete dislikedJobs[jobKey];
  }

  try {
    window.localStorage.setItem(DISLIKED_JOBS_KEY, JSON.stringify(dislikedJobs));
  } catch {
    // Storage is optional; the server and in-memory state remain authoritative for this session.
  }
  return Promise.resolve();
}
